import React from 'react';
import {Grid, InputAdornment, TextField, useMediaQuery, useTheme} from "@mui/material";
import ReactSelect from "react-select";

const filterStyles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        textAlign: "left",
        backgroundColor: "#fff",
        minHeight: 20, 
        padding: "0 8px", 
        height: 34, 
        width: 200,
        fontSize: 14,
        borderColor: "rgb(122, 120, 247)",
        '&:hover': {
            borderColor: "rgb(122, 120, 247)", 
        },
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 1200,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999, 
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: "0px 6px",
    }),
    input: (styles) => ({
        ...styles,
        margin: 0,
        padding: 0, 
    }),
    option: (styles) => ({...styles, textAlign: "left", fontSize: 13}),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)",
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)", 
        },
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "rgba(51, 51, 207, 0.808)",
        marginTop: "0px",
        fontSize: 13,
    }),
    placeholder: (styles) => ({ ...styles, color: "#3333CFCE", marginTop: "0px", fontSize: 12}), 
    noOptionsMessage: (provided) => ({
        ...provided,
        fontStyle: "italic", 
        textAlign: "start", 
        fontSize: "13px", 
    }),
}

const DocumentAuthenticationFilterComponent = (props) => {
    const {selectedStatus, handleKeyDown, type, handleSelectStatusFilter} = props;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const statusList = [
        {label: "Completed", value: "Completed"},
        {label: "Pending", value: "Pending"},
    ]    

    return (
        <Grid container sx={{ justifyContent: isSmallScreen ? "center" : "flex-end", alignItems: "center"}}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: isSmallScreen ? "center" : "flex-end", flexDirection: isSmallScreen ? 'column' : 'row' }}>
                <TextField
                    defaultValue={type}
                    onKeyDown={handleKeyDown}
                    sx={{
                        "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                    }}
                    variant="outlined"
                    autoComplete="off"
                    inputProps={{ style: { padding: "5px 12px", fontSize: 12, fontStyle: 'italic' } }}
                    placeholder="Search Type"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <p style={{ fontWeight: 'bold', fontSize: 12, margin: 0, color: "#3333CFCE" }}>Document Type:</p>
                            </InputAdornment>
                        ),
                    }}
                />

                &nbsp;&nbsp;&nbsp;&nbsp;

                <ReactSelect
                    isRtl={false}
                    options={statusList}
                    value={selectedStatus}
                    onChange={selectedOption => handleSelectStatusFilter(selectedOption)}
                    styles={filterStyles}
                    isClearable={true}
                    placeholder={(selectedStatus) ? null : "Select Status"}
                    noOptionsMessage={() => "No matching status found."} 
                    menuPortalTarget={document.body} 
                    menuPosition="fixed"
                />
            </Grid>
        </Grid>
    );
};

export default DocumentAuthenticationFilterComponent;
